"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commentDeletePermission = exports.commentEditPermission = void 0;
const CommentUserRelationState_1 = require("../schema/CommentUserRelationState");
const plex_1 = require("./plex");
function commentEditPermission(currentUserRelation) {
    switch (currentUserRelation) {
        case CommentUserRelationState_1.CommentUserRelationState.OwnComment:
            return plex_1.Permission.EDIT_OWN_COMMENT;
        case CommentUserRelationState_1.CommentUserRelationState.Comment:
            return null;
    }
}
exports.commentEditPermission = commentEditPermission;
function commentDeletePermission(currentUserRelation) {
    switch (currentUserRelation) {
        case CommentUserRelationState_1.CommentUserRelationState.OwnComment:
            return plex_1.Permission.DELETE_OWN_COMMENT;
        case CommentUserRelationState_1.CommentUserRelationState.Comment:
            return plex_1.Permission.DELETE_COMMENT;
    }
}
exports.commentDeletePermission = commentDeletePermission;
//# sourceMappingURL=comment.js.map